import type { AxiosInstance } from "axios";
import type { APIResponse } from "@/core/types/api";
import type { NewsletterStatus, NewsletterSubscriber } from "./newsletter.type";

export function newsletterService(api: AxiosInstance) {
  return {
    subscribe(email: string): Promise<APIResponse<{ email: string; status: NewsletterStatus }>> {
      return api.post("/newsletter/subscribe", { email }).then((res) => res.data);
    },

    unsubscribe(token: string): Promise<APIResponse<{ email: string; status: NewsletterStatus }>> {
      return api
        .get(`/newsletter/unsubscribe?token=${encodeURIComponent(token)}`)
        .then((res) => res.data);
    },

    getSubscribers(
      filters: { status?: string; search?: string } = {},
      basePath = "/admin/newsletter",
    ): Promise<APIResponse<NewsletterSubscriber[]>> {
      const params = new URLSearchParams();
      if (filters.status) params.append("status", filters.status);
      if (filters.search) params.append("search", filters.search);
      const queryString = params.toString();
      const url = queryString ? `${basePath}?${queryString}` : basePath;

      return api.get(url).then((res) => res.data);
    },
  };
}
